export default __webpack_public_path__ + "images/c17e863c8bd463f2ad39ec5972661e6c-clock.svg";